/*! Titanoré Labs — keep Facebook click id through in-app + locale hops */
(function () {
  try {
    var FBC_KEY = 'tl_fbclid';
    var UTM_KEY = 'tl_utm';
    var CART_KEY = 'tl_fbc_cart';
    var params;
    try {
      params = new URLSearchParams(location.search);
    } catch (e) {
      params = null;
    }

    function storeGet(k) {
      try {
        return sessionStorage.getItem(k) || '';
      } catch (e) {
        return '';
      }
    }
    function storeSet(k, v) {
      try {
        if (v) sessionStorage.setItem(k, v);
      } catch (e) {}
    }

    var fbclid = (params && params.get('fbclid')) || storeGet(FBC_KEY);
    if (fbclid) storeSet(FBC_KEY, fbclid);

    var utm = {};
    try {
      utm = JSON.parse(storeGet(UTM_KEY) || '{}') || {};
    } catch (e) {
      utm = {};
    }
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
      var v = params && params.get(k);
      if (v) utm[k] = v;
    });
    if (Object.keys(utm).length) storeSet(UTM_KEY, JSON.stringify(utm));

    if (fbclid) {
      var existing = '';
      var m = document.cookie.match(/(?:^|; )_fbc=([^;]*)/);
      if (m) {
        try {
          existing = decodeURIComponent(m[1]);
        } catch (e) {
          existing = m[1];
        }
      }
      if (!existing || existing.indexOf(fbclid) === -1) {
        var fbc = 'fb.1.' + Math.floor(Date.now() / 1000) + '.' + fbclid;
        document.cookie =
          '_fbc=' +
          encodeURIComponent(fbc) +
          '; path=/; max-age=7776000; SameSite=Lax; Secure';
      }
    }

    if (!fbclid && !utm.utm_source) return;
    if (storeGet(CART_KEY) === (fbclid || utm.utm_campaign || '1')) return;

    function writeCart() {
      var attrs = {};
      if (fbclid) attrs.fbclid = fbclid;
      Object.keys(utm).forEach(function (k) {
        attrs[k] = utm[k];
      });
      if (!Object.keys(attrs).length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      })
        .then(function (r) {
          if (r.ok) storeSet(CART_KEY, fbclid || utm.utm_campaign || '1');
        })
        .catch(function () {});
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', writeCart);
    } else {
      writeCart();
    }
  } catch (e) {}
})();
